import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  infiniteScroll: {
    overflow: 'hidden !important',
  },
});
